const faqData = [
  {
    question: "What's the core difference between managed IT services and having an in-house IT team?",
    answer: `<p><strong>Managed IT:</strong> You outsource your IT needs to a specialized external company. They handle things like cloud services, hardware/software support, and cybersecurity.</p>
    <p><strong>In-House IT:</strong> You hire your own IT staff to manage all your company's IT needs internally.</p>
    <p>The best choice depends on your budget, needs, and how much support you expect.</p>`
  },
  {
    question: "What are the advantages and disadvantages of each option?",
    answer: `<p><strong>Managed IT Pros:</strong></p>
    <ul>
      <li>Access to expert knowledge and the latest technology</li>
      <li>Often includes 24x7 support</li>
    </ul>
    <p><strong>Managed IT Cons:</strong></p>
    <ul>
      <li>May lack the very specific knowledge of a in house team</li>
    </ul>
    <p><strong>In-House IT Pros:</strong></p>
    <ul>
      <li>Highly tailored support and faster response times for company specific problems</li>
      <li>In depth company knowledge</li>
    </ul>
    <p><strong>In-House IT Cons:</strong></p>
    <ul>
      <li>Can be more expensive and time-consuming to manage</li>
    </ul>`
  },
  {
    question: "Can managed IT benefit my business even if we already have an in-house IT team?",
    answer: `<p>Yes! Managed IT can supplement your in-house team. They can handle specialized tasks (like advanced cybersecurity or cloud management) that your team might not specialize in. This frees up your in-house team for more strategic work.</p>`
  },
  {
    question: "What factors should I consider when choosing between managed IT and in-house IT?",
    answer: `<ul>
      <li><strong>Budget:</strong> How much can you afford?</li>
      <li><strong>IT Needs:</strong> How complex are your IT requirements?</li>
      <li><strong>Resources:</strong> Do you have the time and expertise to manage IT in-house?</li>
    </ul>
    <p>Managed IT is often better for businesses with limited budgets or those needing a wide range of IT services.</p>
    <p>In-house IT might be better for businesses needing highly specialized support and preferring full control.</p>`
  },
  {
    question: "Does managed IT offer support outside of regular business hours?",
    answer: `<p>Yes, many managed IT providers offer 24x7 support. This is a key advantage over in-house IT, which is typically limited to business hours.</p>`
  },
  {
    question: "How can managed IT help my business succeed?",
    answer: `<ul>
      <li>It provides access to a wide range of IT services and expertise</li>
      <li>It allows your in-house staff to focus on core business tasks</li>
      <li>It ensures your IT infrastructure is secure and up-to-date</li>
      <li>It can reduce overall IT costs</li>
    </ul>`
  }
];

export default faqData;
